import React from 'react'
import PropTypes from 'prop-types'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import { updateObject } from 'helpers/objectHelpers'
import FormTextAlign from 'components/forms/FormTextAlign'

const ContainerSettings = ({
  value,
  value: {
    fluid = false,
    textAlign,
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <div>
      <FormCheckbox
        label="Full Width"
        value={fluid}
        onChange={(val) => handleChange(val, 'fluid')}
      />
      <FormTextAlign
        value={textAlign}
        onChange={(val) => handleChange(val, 'textAlign')}
      />
    </div>
  )
}

ContainerSettings.propTypes = {}
ContainerSettings.defaultProps = {}

export default ContainerSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/container/ContainerSettings.js